import { render, staticRenderFns } from "./provinceCityAreaSelect.vue?vue&type=template&id=75bf2152&scoped=true"
import script from "./provinceCityAreaSelect.vue?vue&type=script&lang=js"
export * from "./provinceCityAreaSelect.vue?vue&type=script&lang=js"
import style0 from "./provinceCityAreaSelect.vue?vue&type=style&index=0&id=75bf2152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bf2152",
  null
  
)

export default component.exports